import { fork, all } from 'redux-saga/effects'

import showTypeFormPopup from './showTypeFormPopup'

export default function* identitySaga() {
  yield all([fork(showTypeFormPopup)])
}
